var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.context && _vm.cutdownTime > 0)?_c('div',{staticClass:"activity-cutdown medium"},[_c('div',{staticClass:"context"},[_vm._v(_vm._s(_vm.context))]),_c('div',{staticClass:"time"},[_c('div',{staticClass:"icon"}),_vm._v(" "+_vm._s(_vm._f("formatTime")(_vm.cutdownTime))+" ")])]):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }